const MACHADALO_ORG_ID = 'MAC1421';

export type PlatformUserLike = {
  is_superuser?: boolean;
  profile?: {
    organisation?: { organisation_id?: string };
    organisation_id?: string;
  };
} | null | undefined;

export function isPlatformSuperAdmin(user: PlatformUserLike): boolean {
  if (!user) return false;
  if (user.is_superuser) return true;
  const orgId =
    user.profile?.organisation?.organisation_id ??
    user.profile?.organisation_id ??
    '';
  return orgId === MACHADALO_ORG_ID;
}
